import $ from 'jquery'

class Carousel {
  mode;
  items;
  navLinks;
  itemsContainer;
  navContainer;
  itemTransition;
  index=0;
  position=0;
  constructor(mode, itemsContainer, navContainer) {
    this.mode=mode;
    this.itemsContainer=itemsContainer;
    this.navContainer=navContainer;
    this.items=itemsContainer.find(">*");
    this.navLinks=navContainer.find(">*");

    if (this.mode=="fade")
      this.itemTransition=new CarouselFade(this.itemContainer, this.items);

    var that=this;
    this.navLinks.click(function (e) {
      e.preventDefault();
      var newIndex=that.navLinks.index(this);
      that.moveTo(newIndex);
    });
    this.moveTo(0);
    this.doNextInterval();
  }
  moveTo(index) {
    this.index=index;
    this.position=0;
    this.updateLinks();
    this.updateItems();
    this.doNextInterval();
  }
  updateItems() {
    this.itemTransition.index=this.index;
    this.itemTransition.position=this.position;
    this.itemTransition.updateItems();
  }
  updateLinks() {
    this.navLinks.removeClass("active").eq(this.index).addClass("active");
  }
  doNextInterval() {
    clearInterval(this.nextInterval);
    this.nextInterval=setInterval(()=>this.moveTo((this.index+1)%this.items.length), 25000);
  }
}

class CarouselFade {
  itemContainer;
  items;
  index=0;
  position=0;
  lru=[];
  constructor(itemContainer, items) {
    this.itemContainer=itemContainer;
    this.items=items;
  }
  updateItems() {
    if (this.lru.indexOf(this.index*1)!=-1)
      this.lru.splice(this.lru.indexOf(this.index*1), 1);
    this.lru.push(this.index*1);
    for(var i=0;i<this.items.length;i++) {
      this.items.eq(i).css({"z-index": this.lru.indexOf(i)});
    }
    this.items.css({"transition": "none"}).eq(this.index).css({"opacity": "0"});
    setTimeout(()=>{
      this.items.eq(this.index).css({"opacity": 1, "transition": "opacity .3s"});
    }, 16);
    this.items.find("video").each(function() { this.pause(); })
    this.items.eq(this.index).find("video").each(function() {
      this.currentTime=0;
      this.play();
    });
  }
}


$("[data-carousel]").each(function() {
  new Carousel($(this).attr("data-carousel"),
               $(this).find("[data-carousel-role=items]"),
               $(this).find("[data-carousel-role=nav]"));
});
